import { useMutation } from "@tanstack/react-query"
import axios, { AxiosError } from "axios"
import { useQueryClient } from "@tanstack/react-query"
import { displayNotify } from "../../../../../shared/services/Notifications/NotificationServices"

interface RequestData {
    status: string,
    username?: string
}

const descriptionStatus = (status: string) => {
    if (status === 'approved') {
        return 'Заявка принята'
    } else return 'Заявка отклонена'
}


export default function useManageRequest(guID?: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (request: RequestData) => {
            const response = await axios.patch(`/events/${guID}/registration/${request.username}/`, {
                status: request.status
            })

            return { status: request.status }
        },
        onSuccess: ({ status }) => {
            queryClient.invalidateQueries({ queryKey: ['eventRequests', guID] })
            displayNotify({
                status: 'success',
                title: 'Изменения сохранены',
                description: `${descriptionStatus(status)}`
            })
        },
        onError: () => {
            displayNotify({
                status: 'error',
                title: 'Что-то пошло не так',
                description: "Пожалуйста, повторите попытку позже"
            })
        }
    })
}